import { render } from "./TreeSelect.vue?vue&type=template&id=245c5e90&scoped=true&ts=true"
import script from "./TreeSelect.vue?vue&type=script&lang=ts"
export * from "./TreeSelect.vue?vue&type=script&lang=ts"

import "./TreeSelect.vue?vue&type=style&index=0&id=245c5e90&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-245c5e90"]])

export default __exports__